import {REQUEST_PRODUCTS, RECEIVE_PRODUCTS, REQUEST_FILTERS, RECEIVE_FILTERS, UPDATE_PRODUCTS_PRINTER, UPDATE_PRODUCTS} from '../constants/actionTypes';
import objectAssign from 'object-assign';
import initialState from './initialState';

const updateProducts = (state, id, isSaved) => {
  let items = state.products.items.map(product => {
    if (product.id === id) {
      product = Object.assign({}, product);
      product.isSaved = isSaved;
    }
    return product;
  });

  return Object.assign({}, state, {
    products: {
      items,
      total: state.products.total,
    }
  });
};

// IMPORTANT: Note that with Redux, state should NEVER be changed.
// State is considered immutable. Instead,
// create a copy of the state passed and set new values on the copy.
// Note that I'm using Object.assign to create a copy of current state
// and update values on the copy.
export default function productsReducer(state = initialState, action) {
  switch (action.type) {
    case REQUEST_PRODUCTS:
      return objectAssign({}, state, {
        isFetching: true
      });

    case RECEIVE_PRODUCTS:
      return objectAssign({}, state, {
        products: {
          items: action.data.items,
          total: action.data.total,
        },
        printer: action.data.printer,
        isFetching: false
      });

    case REQUEST_FILTERS:
      return objectAssign({}, state, {
        isFetchingFilters: true
      });

    case RECEIVE_FILTERS:
      return objectAssign({}, state, {
        filters: action.data.filters,
        isFetchingFilters: false
      });

    case UPDATE_PRODUCTS_PRINTER:
      return objectAssign({}, state, {
        printer: objectAssign({}, state.printer, { isSaved:action.isSaved })
      });

    case UPDATE_PRODUCTS:
      return updateProducts(state, action.data.id, action.data.isSaved);

    default:
      state.isFetching = true;
      return state;
  }
}
